import { useSyncExternalStore } from 'react';

const NAVIGATION_EVENT = 'ada:navigation';

let isHistoryPatched = false;

const patchHistory = () => {
  if (isHistoryPatched) return;

  isHistoryPatched = true;

  (['pushState', 'replaceState'] as const).forEach((method) => {
    const original = window.history[method];

    window.history[method] = function patched(...args) {
      original.apply(this, args);
      window.dispatchEvent(new Event(NAVIGATION_EVENT));
    };
  });
};

const subscribe = (onChange: () => void) => {
  patchHistory();

  window.addEventListener('popstate', onChange);
  window.addEventListener('hashchange', onChange);
  window.addEventListener(NAVIGATION_EVENT, onChange);

  return () => {
    window.removeEventListener('popstate', onChange);
    window.removeEventListener('hashchange', onChange);
    window.removeEventListener(NAVIGATION_EVENT, onChange);
  };
};

const getSnapshot = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

const useCurrentUrl = () => useSyncExternalStore(subscribe, getSnapshot);

export default useCurrentUrl;
